export default "__VITE_ASSET__Z22EFPxS__"